var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 161.972,
    height: 151.653,
    viewBox: "0 0 161.972 151.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.367,
    y1: 1.185,
    x2: 0.462,
    y2: -0.429,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 1.418,
    x2: 0.5,
    y2: -0.418,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.637,
    y1: 0.767,
    x2: 0.728,
    y2: 0.223,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.976,
    y1: 0.175,
    x2: -0.014,
    y2: 1.057,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feffff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_353",
    "data-name": "Groupe 353",
    transform: "translate(-888.37 -419.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_352",
    "data-name": "Groupe 352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_folder_x4ft",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 882.437, 441.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_433",
    "data-name": "Trac\\xE9 433",
    d: "M534.02,342H513.53V258.73h38.262Z",
    transform: "translate(-413.738 -208.483)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_434",
    "data-name": "Trac\\xE9 434",
    d: "M530.454,342H510.37V258.73h37.5Z",
    transform: "translate(-411.192 -208.483)",
    fill: "#f6f7fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1211",
    "data-name": "Rectangle 1211",
    width: 85.349,
    height: 32.813,
    transform: "matrix(0.963, -0.269, 0.269, 0.963, -0.004, 22.94)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1212",
    "data-name": "Rectangle 1212",
    width: 83.922,
    height: 31.762,
    transform: "matrix(0.963, -0.269, 0.269, 0.963, 0.976, 23.159)",
    fill: "#f6f7fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1213",
    "data-name": "Rectangle 1213",
    width: 21.114,
    height: 1.611,
    transform: "matrix(0.963, -0.269, 0.269, 0.963, 25.947, 27.744)",
    fill: "#39499b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1214",
    "data-name": "Rectangle 1214",
    width: 21.114,
    height: 1.611,
    transform: "matrix(0.963, -0.269, 0.269, 0.963, 27.681, 33.947)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1215",
    "data-name": "Rectangle 1215",
    width: 33.93,
    height: 1.611,
    transform: "matrix(0.963, -0.269, 0.269, 0.963, 26.813, 30.844)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 3.758,
    cy: 3.758,
    r: 3.758,
    transform: "matrix(0.963, -0.269, 0.269, 0.963, 13.697, 31.447)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1216",
    "data-name": "Rectangle 1216",
    width: 85.751,
    height: 33.264,
    transform: "translate(24.311 36.927) rotate(-20.42)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1217",
    "data-name": "Rectangle 1217",
    width: 83.922,
    height: 31.762,
    transform: "translate(25.42 37.448) rotate(-20.42)",
    fill: "#f6f7fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1218",
    "data-name": "Rectangle 1218",
    width: 21.114,
    height: 1.611,
    transform: "translate(50.687 39.927) rotate(-20.42)",
    fill: "#39499b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1219",
    "data-name": "Rectangle 1219",
    width: 21.114,
    height: 1.611,
    transform: "translate(52.935 45.963) rotate(-20.42)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1220",
    "data-name": "Rectangle 1220",
    width: 34.034,
    height: 1.616,
    transform: "matrix(0.937, -0.349, 0.349, 0.937, 52.147, 43.001)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 3.758,
    cy: 3.758,
    r: 3.758,
    transform: "translate(38.789 44.643) rotate(-20.42)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1221",
    "data-name": "Rectangle 1221",
    width: 33.458,
    height: 85.533,
    transform: "matrix(0.175, -0.984, 0.984, 0.175, 51.681, 61.115)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1222",
    "data-name": "Rectangle 1222",
    width: 83.922,
    height: 31.762,
    transform: "matrix(0.984, 0.175, -0.175, 0.984, 57.951, 28.956)",
    fill: "#f6f7fe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1223",
    "data-name": "Rectangle 1223",
    width: 1.611,
    height: 21.114,
    transform: "matrix(0.175, -0.984, 0.984, 0.175, 78.176, 45.509)",
    fill: "#39499b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1224",
    "data-name": "Rectangle 1224",
    width: 1.611,
    height: 21.114,
    transform: "matrix(0.175, -0.984, 0.984, 0.175, 77.048, 51.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1225",
    "data-name": "Rectangle 1225",
    width: 1.611,
    height: 33.93,
    transform: "matrix(0.175, -0.984, 0.984, 0.175, 77.611, 48.681)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 3.758,
    cy: 3.758,
    r: 3.758,
    transform: "matrix(0.175, -0.984, 0.984, 0.175, 64.496, 49.343)",
    fill: "#181a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_435",
    "data-name": "Trac\\xE9 435",
    d: "M35.05,213.544,21.219,203.86H2.07v95.462H121.751V213.544Z",
    transform: "translate(-1.671 -164.276)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_436",
    "data-name": "Trac\\xE9 436",
    d: "M39.813,219.76l-13.619-9.4H7.34v92.665H125.179V219.76Z",
    transform: "translate(-5.917 -169.513)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7",
    "data-name": "Groupe 7",
    transform: "translate(941.678 499.354) rotate(-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_211",
    "data-name": "Trac\\xE9 211",
    d: "M90.726,68.75v.686a31.142,31.142,0,0,0-15.97,0A27.374,27.374,0,0,0,70.7,70.857c-.2.1-.431.178-.634.279-.127.051-.279.127-.406.178h0a30.444,30.444,0,0,0-5.7,3.5,36.887,36.887,0,0,1-.507-5.256L63.4,67.709l1.622-.889a40.925,40.925,0,0,1,4.791-2.209c.254-.1.507-.178.786-.279a31.826,31.826,0,0,1,4.791-1.3,37.061,37.061,0,0,1,14.7,0A24.825,24.825,0,0,1,90.726,68.75Z",
    transform: "translate(-63.4 -62.3)",
    fill: "#39499b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_212",
    "data-name": "Trac\\xE9 212",
    d: "M171.284,74.249l-.051,1.854a36.526,36.526,0,0,1-.507,5.256c-.051.279-.1.533-.152.813A34.606,34.606,0,0,1,169.307,87a38.763,38.763,0,0,1-2.205,5.18q-.38.762-.837,1.524a36.309,36.309,0,0,1-4.309,5.993,24.983,24.983,0,0,1-5.856-2.666,30.128,30.128,0,0,0,6.185-8.862,29.792,29.792,0,0,0,1.8-4.977,31.028,31.028,0,0,0,.938-5.383c.076-.838.1-1.7.1-2.565a31.817,31.817,0,0,0-.279-4.139,37.015,37.015,0,0,1,4.791,2.184Z",
    transform: "translate(-132.602 -68.865)",
    fill: "#39499b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_213",
    "data-name": "Trac\\xE9 213",
    d: "M88.489,127.115c-.355-.254-.735-.508-1.09-.787-.127-.1-.228-.178-.355-.279-.38-.3-.76-.609-1.141-.94-.152-.127-.279-.254-.431-.381-.406-.355-.786-.736-1.166-1.117a30.125,30.125,0,0,1-6.185-8.862s.254.711.279.711c.558-.736,3.726-2.209,4.69-2.361a23.257,23.257,0,0,0,5.374,7.313,25.594,25.594,0,0,0,5.577-7.719,24.625,24.625,0,0,0,1.724-4.926,25.521,25.521,0,0,0-14.6,0,24.707,24.707,0,0,0-4.842,2.031h0a25.634,25.634,0,0,0-5.222,3.783,35.705,35.705,0,0,0,2.205,5.18q.38.762.837,1.524a36.313,36.313,0,0,0,4.309,5.993,38.287,38.287,0,0,0,3.523,3.5c.2.178.431.355.634.533a33.636,33.636,0,0,0,4.284,3.047l1.572.965,1.6-.965a33.821,33.821,0,0,0,4.284-3.072,29.063,29.063,0,0,1-5.856-3.174Z",
    transform: "translate(-69.148 -95.426)",
    fill: "#39499b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImg);
export default __webpack_public_path__ + "static/media/uploadImg.40ede22644f105c048a6a3b9d54f6a41.svg";
export { ForwardRef as ReactComponent };